var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H35C37.7614 0 40 2.23858 40 5V35C40 37.7614 37.7614 40 35 40H5C2.23858 40 0 37.7614 0 35V5Z",
    fill: "#FEF6F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.79 11.29L23.5 12H26C26.55 12 27 12.45 27 13C27 13.55 26.55 14 26 14H14C13.45 14 13 13.55 13 13C13 12.45 13.45 12 14 12H16.5L17.21 11.29C17.39 11.11 17.65 11 17.91 11H22.09C22.35 11 22.61 11.11 22.79 11.29ZM14 27C14 28.1 14.9 29 16 29H24C25.1 29 26 28.1 26 27V17C26 15.9 25.1 15 24 15H16C14.9 15 14 15.9 14 17V27ZM17.17 19.17C17.56 18.78 18.19 18.78 18.58 19.17L20 20.59L21.42 19.17C21.81 18.78 22.44 18.78 22.83 19.17C23.22 19.56 23.22 20.19 22.83 20.58L21.41 22L22.83 23.42C23.22 23.81 23.22 24.44 22.83 24.83C22.44 25.22 21.81 25.22 21.42 24.83L20 23.41L18.58 24.83C18.19 25.22 17.56 25.22 17.17 24.83C16.9827 24.6432 16.8775 24.3895 16.8775 24.125C16.8775 23.8605 16.9827 23.6068 17.17 23.42L18.59 22L17.17 20.58C16.78 20.2 16.78 19.56 17.17 19.17Z",
    fill: "#E84C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBtn);
export default __webpack_public_path__ + "static/media/DeleteBtn.f767f91bdd51ac61bfbf6d0f9f775da7.svg";
export { ForwardRef as ReactComponent };